import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";
export default {
  namespace: true,
  state: {
    isLoggedIn: !!localStorage.getItem("isLoggedIn"),
    user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null,
  },
  mutations,
  getters,
  actions,
};
